import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=4374bdff&"
import script from "./SignupForm.vue?vue&type=script&lang=js&"
export * from "./SignupForm.vue?vue&type=script&lang=js&"
import style0 from "./SignupForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4374bdff')) {
      api.createRecord('4374bdff', component.options)
    } else {
      api.reload('4374bdff', component.options)
    }
    module.hot.accept("./SignupForm.vue?vue&type=template&id=4374bdff&", function () {
      api.rerender('4374bdff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/auth/SignupForm.vue"
export default component.exports